<script>
  import { onMount } from 'svelte'
  import { sliderReviews, getSliderReviews } from '../stores'
  import Reviews from './ReviewsContent.svelte'
  import Carousel from './slider/Carousel.svelte'
  import NoReviews from './ReviewsContent/NoReviews.svelte'
  import { isMobileBrowser, getFontFamily, isObjectEmpty } from '../utils.js'
  import configModule from '../config'
  import FontLoader from '../components/FontLoader.svelte'
  import fontsMod from '../fonts'
  import loggerMod from '../loader/log'

  const MAX_RATING = 5

  export let settingsResponse

  let reviews = []
  let settings
  let loading = true
  let averageRating = 0
  let totalCount = 0
  let fontType
  let showOnDevice
  let backgroundTransparent
  let textColor
  let backgroundColor
  let isMobile
  let isMedia

  const config = configModule()
  const fonts = fontsMod()
  const log = loggerMod()

  onMount(async () => {
    const businessId = config.aid
    const clientId = config.apiKey

    isMobile = isMobileBrowser()

    try {
      settings = settingsResponse.data
      fontType = settings.widget_settings.general_settings.font_type
      backgroundTransparent =
        settings.widget_settings.slider.background_transparent
      textColor = settings.widget_settings.general_settings.text_colour
      backgroundColor =
        settings.widget_settings.general_settings.background_color
      showOnDevice =
        (isMobile && settings.widget_settings.slider.mobile_visibility) ||
        (!isMobile && settings.widget_settings.slider.desktop_visibility)
      isMedia =
        settings.widget_settings.general_settings.show_media_reviews_only
      if (showOnDevice) {
        const res = !isObjectEmpty($sliderReviews)
          ? $sliderReviews
          : await getSliderReviews({
              businessId,
              clientId,
              limit: 50,
              ...(isMedia && { isMedia })
            })
        reviews = res.data
        averageRating = res.metadata.average
        totalCount = res.metadata.count

        loading = false
      }
    } catch (error) {
      log.error(error)
    } finally {
      config.isPreview &&
        window.dispatchEvent(new Event(config.previewLoadedEvent))
    }
  })
</script>

<style>
  :global(#kbz-slider-wrapper *) {
    box-sizing: content-box;
    font-family: var(--fontFamily);
  }

  #kbz-slider-wrapper {
    background: var(--background);
    margin: 50px auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    -webkit-tap-highlight-color: transparent;
    text-align: center;
    font-family: var(--fontFamily);
  }

  #kbz-slider-wrapper > :global(*.kbz_reviews_card) {
    margin: 0;
    width: 350px;
  }

  .slider-v1 {
    max-width: 100%;
  }

  .slider-v1 > :global(*.kbz_reviews_card) {
    margin: 0;
    width: 350px;
  }
  .no-reviews {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  #subdomain__link {
    color: inherit;
  }
</style>

{#if !loading}
  <FontLoader {fontType} />
  <div
    id="kbz-slider-wrapper"
    style="--background:{backgroundTransparent ? 'transparent' : backgroundColor};
    {fonts[fontType] ? `--fontFamily: ${getFontFamily(fonts[fontType])};` : ''}">
    {#if reviews.length === 0}
      <section class="$style.no-reviews">
        <NoReviews {textColor} />
      </section>
    {:else}
      <section class="$style.slider-v1">
        <div id="MyCarousel">
          <Carousel>
            <Reviews {isMobile} {reviews} {settings} />
          </Carousel>
        </div>
        {#if !isMobile}
          <div style="color: {textColor};">
            {settings.translations.slider.rated_text}
            <strong>{averageRating}</strong>
            {settings.translations.slider.out_of_text} {MAX_RATING}
            {settings.translations.based_on_text}
            <a
              id="subdomain__link"
              href="https://kudobuzz.reviews/{settings.handle}"
              rel="noopener"
              target="_blank">
              <strong>
                {totalCount} {settings.translations.slider.reviews_on_text}
                Kudobuzz
              </strong>
            </a>
          </div>
        {/if}
      </section>
    {/if}
  </div>
{/if}
